module.exports = __webpack_public_path__ + "static/img/erweima.9093f442.png";